/* global kakao */
import React, {useEffect} from "react";
import '../css/Location.css'


const Location=()=>{
    const { kakao } = window;
    useEffect(()=>{
        let container = document.getElementById("map");
        let options = {
            center: new window.kakao.maps.LatLng(33.5073505, 126.514493),
            level: 4,
        };
        let map = new window.kakao.maps.Map(container, options);
        let markerPosition = new kakao.maps.LatLng(
            33.5073505, 126.514493
        );

        // 마커를 생성
        let marker = new kakao.maps.Marker({
            position: markerPosition,
        });

        // 마커를 지도 위에 표시
        marker.setMap(map);

    },[])
    return(
        <>
            <div className={'location-container'}>
                <div className={"location-title-background-box"}>
                    <div className={'red-dot-box'}>
                        <div className={'red-dot'}/>
                    </div>
                    <h3>오시는길</h3>
                </div>
                <div className={'flex__center location-map-box'}>
                    <div className={'flex__center'}>
                        <h4>매장 위치</h4>
                        <div className={'map-box'} id={"map"}/>
                        <br/>
                        <span>제주특별자치도 제주시 용남1길 16 1층 제주앙</span>
                    </div>
                    <br/>
                    <div className={'flex__center'}>
                        <h4>주차장 위치</h4>
                        <img src={process.env.PUBLIC_URL +'/img/parking.png'} alt={'parking'} width={"500px"}/>
                        <br/>
                        <span>제주특별자치도 제주시 용남1길 16 1층 제주앙</span>
                    </div>

                </div>

            </div>
        </>
    );
}

export default Location
